/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination';

export class RestoreAzureSqlVmPitrRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  /**
  * Eon-assigned ID of the backup vault to restore from.
  */
  'vaultId': string;
  /**
  * The date and time to restore the SQL Server databases to (in UTC). Eon will find the appropriate PITR snapshot covering this timestamp and restore the databases to this exact point in time using SQL Server transaction log replay.  If not specified, restores to the most recent available point.  Format: ISO 8601 (e.g., \"2026-02-10T09:07:32Z\") 
  */
  'restoreToTime'?: Date;
  'destination': AzureVmInstanceRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreToTime",
      "baseName": "restoreToTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "AzureVmInstanceRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAzureSqlVmPitrRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

